// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SurveyRouteImport } from './routes/survey'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as ClosedBetaRouteImport } from './routes/closed-beta'
import { Route as AppQrRouteImport } from './routes/app-qr'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedHostRouteImport } from './routes/_authed/host'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedHostIndexRouteImport } from './routes/_authed/host/index'
import { Route as AuthedHostMagicNumbersRouteImport } from './routes/_authed/host/magic-numbers'
import { Route as AuthedHostEventsRouteImport } from './routes/_authed/host/events'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedAdminVenuesRouteImport } from './routes/_authed/admin/venues'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin/users'
import { Route as AuthedAdminSettingsRouteImport } from './routes/_authed/admin/settings'
import { Route as AuthedAdminSentryTestRouteImport } from './routes/_authed/admin/sentry-test'
import { Route as AuthedAdminRewardsRouteImport } from './routes/_authed/admin/rewards'
import { Route as AuthedAdminMagicNumbersRouteImport } from './routes/_authed/admin/magic-numbers'
import { Route as AuthedAdminGamesRouteImport } from './routes/_authed/admin/games'
import { Route as AuthedAdminEventsRouteImport } from './routes/_authed/admin/events'
import { Route as AuthedAdminEconomyRouteImport } from './routes/_authed/admin/economy'
import { Route as AuthedAdminContentRouteImport } from './routes/_authed/admin/content'
import { Route as AuthedAdminCampaignsRouteImport } from './routes/_authed/admin/campaigns'
import { Route as AuthedAdminAuditRouteImport } from './routes/_authed/admin/audit'
import { Route as AuthedAdminAnalyticsRouteImport } from './routes/_authed/admin/analytics'
import { Route as AuthedHostGamesGameIdRouteImport } from './routes/_authed/host/games.$gameId'
import { Route as AuthedHostEventsNewRouteImport } from './routes/_authed/host/events.new'
import { Route as AuthedHostEventsEventIdRouteImport } from './routes/_authed/host/events.$eventId'
import { Route as AuthedHostGamesGameIdStatsRouteImport } from './routes/_authed/host/games.$gameId.stats'

const SurveyRoute = SurveyRouteImport.update({
            id: '/survey',path: '/survey',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const DownloadRoute = DownloadRouteImport.update({
            id: '/download',path: '/download',getParentRoute: () => rootRouteImport
          })
const DeleteAccountRoute = DeleteAccountRouteImport.update({
            id: '/delete-account',path: '/delete-account',getParentRoute: () => rootRouteImport
          })
const ClosedBetaRoute = ClosedBetaRouteImport.update({
            id: '/closed-beta',path: '/closed-beta',getParentRoute: () => rootRouteImport
          })
const AppQrRoute = AppQrRouteImport.update({
            id: '/app-qr',path: '/app-qr',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthedHostRoute = AuthedHostRouteImport.update({
            id: '/host',path: '/host',getParentRoute: () => AuthedRoute
          })
const AuthedAdminRoute = AuthedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthedRoute
          })
const AuthedHostIndexRoute = AuthedHostIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedHostRoute
          })
const AuthedHostMagicNumbersRoute = AuthedHostMagicNumbersRouteImport.update({
            id: '/magic-numbers',path: '/magic-numbers',getParentRoute: () => AuthedHostRoute
          })
const AuthedHostEventsRoute = AuthedHostEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthedHostRoute
          })
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminVenuesRoute = AuthedAdminVenuesRouteImport.update({
            id: '/venues',path: '/venues',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminSettingsRoute = AuthedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminSentryTestRoute = AuthedAdminSentryTestRouteImport.update({
            id: '/sentry-test',path: '/sentry-test',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminRewardsRoute = AuthedAdminRewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminMagicNumbersRoute = AuthedAdminMagicNumbersRouteImport.update({
            id: '/magic-numbers',path: '/magic-numbers',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminGamesRoute = AuthedAdminGamesRouteImport.update({
            id: '/games',path: '/games',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminEventsRoute = AuthedAdminEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminEconomyRoute = AuthedAdminEconomyRouteImport.update({
            id: '/economy',path: '/economy',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminContentRoute = AuthedAdminContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminCampaignsRoute = AuthedAdminCampaignsRouteImport.update({
            id: '/campaigns',path: '/campaigns',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAuditRoute = AuthedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthedAdminRoute
          })
const AuthedAdminAnalyticsRoute = AuthedAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthedAdminRoute
          })
const AuthedHostGamesGameIdRoute = AuthedHostGamesGameIdRouteImport.update({
            id: '/games/$gameId',path: '/games/$gameId',getParentRoute: () => AuthedHostRoute
          })
const AuthedHostEventsNewRoute = AuthedHostEventsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthedHostEventsRoute
          })
const AuthedHostEventsEventIdRoute = AuthedHostEventsEventIdRouteImport.update({
            id: '/$eventId',path: '/$eventId',getParentRoute: () => AuthedHostEventsRoute
          })
const AuthedHostGamesGameIdStatsRoute = AuthedHostGamesGameIdStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => AuthedHostGamesGameIdRoute
          })





const AuthedAdminRouteChildren = {
  AuthedAdminAnalyticsRoute: AuthedAdminAnalyticsRoute,AuthedAdminAuditRoute: AuthedAdminAuditRoute,AuthedAdminCampaignsRoute: AuthedAdminCampaignsRoute,AuthedAdminContentRoute: AuthedAdminContentRoute,AuthedAdminEconomyRoute: AuthedAdminEconomyRoute,AuthedAdminEventsRoute: AuthedAdminEventsRoute,AuthedAdminGamesRoute: AuthedAdminGamesRoute,AuthedAdminMagicNumbersRoute: AuthedAdminMagicNumbersRoute,AuthedAdminRewardsRoute: AuthedAdminRewardsRoute,AuthedAdminSentryTestRoute: AuthedAdminSentryTestRoute,AuthedAdminSettingsRoute: AuthedAdminSettingsRoute,AuthedAdminUsersRoute: AuthedAdminUsersRoute,AuthedAdminVenuesRoute: AuthedAdminVenuesRoute,AuthedAdminIndexRoute: AuthedAdminIndexRoute
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(AuthedAdminRouteChildren)




const AuthedHostEventsRouteChildren = {
  AuthedHostEventsEventIdRoute: AuthedHostEventsEventIdRoute,AuthedHostEventsNewRoute: AuthedHostEventsNewRoute
}

const AuthedHostEventsRouteWithChildren = AuthedHostEventsRoute._addFileChildren(AuthedHostEventsRouteChildren)




const AuthedHostGamesGameIdRouteChildren = {
  AuthedHostGamesGameIdStatsRoute: AuthedHostGamesGameIdStatsRoute
}

const AuthedHostGamesGameIdRouteWithChildren = AuthedHostGamesGameIdRoute._addFileChildren(AuthedHostGamesGameIdRouteChildren)



const AuthedHostRouteChildren = {
  AuthedHostEventsRoute: AuthedHostEventsRouteWithChildren,AuthedHostMagicNumbersRoute: AuthedHostMagicNumbersRoute,AuthedHostIndexRoute: AuthedHostIndexRoute,AuthedHostGamesGameIdRoute: AuthedHostGamesGameIdRouteWithChildren
}

const AuthedHostRouteWithChildren = AuthedHostRoute._addFileChildren(AuthedHostRouteChildren)



const AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,AuthedHostRoute: AuthedHostRouteWithChildren
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthedRoute: AuthedRouteWithChildren,AppQrRoute: AppQrRoute,ClosedBetaRoute: ClosedBetaRoute,DeleteAccountRoute: DeleteAccountRoute,DownloadRoute: DownloadRoute,PrivacyRoute: PrivacyRoute,SignInRoute: SignInRoute,SupportRoute: SupportRoute,SurveyRoute: SurveyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)